import styled from 'styled-components';
import { Navbar } from '../Navbar/Navbar';

const LayoutContainer = styled.div`
  min-height: 100vh;
  padding-top: 60px; // Altura da navbar
`;

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <LayoutContainer>
      <Navbar />
      {children}
    </LayoutContainer>
  );
}; 